import { useState } from 'react';
import { useAuth } from '@/contexts/AuthProvider';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Card, CardHeader, CardContent, CardFooter } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { useNavigate } from 'react-router-dom';
import { LoadingSpinner } from '@/components/ui/LoadingSpinner';
import { supabase } from '@/lib/supabase';
import { Link } from 'react-router-dom';
import { FcGoogle } from 'react-icons/fc';
import { toast } from '@/components/ui/use-toast';
import { authService } from '@/services/auth';

export function LoginForm() {
  console.log("LoginForm mounted");
  
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [formLoading, setFormLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setFormLoading(true);
    try {
      await authService.signIn(email, password);
      toast({
        title: "Logged in successfully!",
        variant: "default"
      });
      // No redirect needed; AuthProvider will handle navigation
    } catch (err: any) {
      setError(err.message);
    } finally {
      setFormLoading(false);
    }
  };

  const handleGoogleLogin = async () => {
    console.log('authService:', authService);
    console.log('typeof signInWithGoogle:', typeof authService.signInWithGoogle);
    try {
      console.log('🔵 Initiating Google login');
      await authService.signInWithGoogle();
      // No need to check result - errors will be caught below
    } catch (err: any) {
      console.error('🔴 Google login failed:', err);
      setError(err.message);
    }
  };

  return <Card className="w-[350px]">
      <CardHeader>
        <h2 className="text-2xl font-bold text-center">Backed by On Wheels. Always</h2>
      </CardHeader>
      <CardContent>
        <form onSubmit={handleSubmit} className="space-y-4">
          {error && <Alert variant="destructive">
              <AlertDescription>{error}</AlertDescription>
            </Alert>}
          
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} required />
          </div>
          
          <div className="space-y-2">
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" value={password} onChange={e => setPassword(e.target.value)} required />
          </div>
          
          <Button
            type="submit"
            className="w-full"
            disabled={formLoading}
          >
            {formLoading ? (
              <LoadingSpinner className="h-5 w-5" />
            ) : (
              "Log in"
            )}
          </Button>

          <div className="relative my-4">
            <div className="absolute inset-0 flex items-center">
              <span className="w-full border-t" />
            </div>
            <div className="relative flex justify-center text-xs uppercase">
              <span className="bg-background px-2 text-muted-foreground">OR</span>
            </div>
          </div>

          <Button 
            type="button"
            variant="secondary" 
            onClick={handleGoogleLogin}
            className="w-full"
          >
            <FcGoogle className="mr-2 h-4 w-4" />
            Continue with Google
          </Button>
        </form>
      </CardContent>
      <CardFooter className="flex justify-center">
        <Link 
          to="/onboarding/signup"
          className="text-[#7097fa] hover:text-[#7097fa]/90 mt-4 text-sm font-medium"
        >
          Create new account
        </Link>
      </CardFooter>
    </Card>;
}
